var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShares = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M14.912 19.856H5.549"
})), /*#__PURE__*/React.createElement("mask", {
  id: "shares_svg__a",
  width: 25,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.25 0h24v24h-24z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#shares_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M17.06 15.984v5.66a1.887 1.887 0 0 1-1.888 1.887H5.286a1.887 1.887 0 0 1-1.888-1.887V2.356c0-1.042.845-1.887 1.888-1.887h9.886c1.043 0 1.888.845 1.888 1.887v5.121M7.232 2.795h3.433M12.758 2.795h.467M9.57 21.686h1.32"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  d: "M15.53 5.205a6.04 6.04 0 0 0-4.98 9.458l-.709 1.822 1.914-.526A6.04 6.04 0 1 0 15.53 5.205"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M14.29 11.244a1.23 1.23 0 1 1-2.462 0 1.23 1.23 0 0 1 2.461 0M17.993 9.26a1.006 1.006 0 1 1-2.013 0 1.006 1.006 0 0 1 2.013 0M17.993 13.228a1.006 1.006 0 1 1-2.013 0 1.006 1.006 0 0 1 2.013 0M14.29 10.73l1.742-.963M14.29 11.76l1.742.963"
}))));
export default SvgShares;